import React, { useState } from "react";
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField, MenuItem, Stack } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useUpdateCenterMutation, useGetCenterTypesQuery } from "../../../../services/ConfigurationService";

interface AddCenterDialogProps {
  organization?: string;
}

const AddCenterDialog: React.FC<AddCenterDialogProps> = ({ organization }) => {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({
    code: "",
    shortName: "",
    centerType: "UNK",
    pas: "",
    systemId: "",
    dimensionName: "",
  });
  const [updateCenter, { isLoading: isSaving }] = useUpdateCenterMutation();
  const { data: centerTypes, isLoading: centerTypesLoading } = useGetCenterTypesQuery();

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async () => {
    if (!organization) return;
    await updateCenter({
      id: organization + '-' + form.code,
      code: form.code,
      name: form.shortName, // Use shortName as name for now
      shortName: form.shortName,
      centerType: form.centerType,
      pas: form.pas,
      address: { address1: "", address2: "", city: "", state: "", zip: "", country: "" },
      contactInfo: { phone: "", fax: "", email: "" },
      medicareConfig: { providerNumber: "", npi: "", isCriticalAccess: false },
      govtIdent: { taxId: "", npi: "" },
      medicareRates: [],
      outlierConfigs: [],
      appConfig: { allowManualScheduling: false, authNotificationEmail: "", staffNotificationGroupId: "", sageLocation: "" },
      sageLocation: "",
      isInactive: false,
      company: organization,
      attributes: {
        systemId: form.systemId.trim(),
        name: form.dimensionName.trim(),
      },
    });
    setOpen(false);
    setForm({ code: "", shortName: "", centerType: "UNK", pas: "", systemId: "", dimensionName: "" });
  };

  return (
    <>
      <Button variant="contained" color="primary" onClick={handleOpen}>
        Add Center
      </Button>
      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogTitle>Add New Center</DialogTitle>
        <DialogContent>
          <Stack spacing={2} sx={{ minWidth: 350, p: 1 }}>
            <TextField label="Code" name="code" value={form.code} onChange={handleChange} fullWidth required />
            <TextField label="Short Name" name="shortName" value={form.shortName} onChange={handleChange} fullWidth required />
            <TextField select label="Type" name="centerType" value={form.centerType} onChange={handleChange} fullWidth required disabled={centerTypesLoading}>
              {(centerTypes || []).map((option) => (
                <MenuItem key={option.value} value={option.value}>{option.name}</MenuItem>
              ))}
            </TextField>
            <TextField label="PAS" name="pas" value={form.pas} onChange={handleChange} fullWidth required />
            <TextField label="System ID" name="systemId" value={form.systemId} onChange={handleChange} fullWidth />
            <TextField label="Dim.Facility Name" name="dimensionName" value={form.dimensionName} onChange={handleChange} fullWidth />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} disabled={isSaving}>Cancel</Button>
          <Button variant="contained" color="primary" onClick={handleSave} disabled={isSaving}>Save</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export { AddCenterDialog };


